import React from "react";
import { useEffect } from "react";
import { Outlet } from "react-router";
import { SETTINGS_PAGE } from "../../utils/constants";
import { logEvents, trackEvent } from "../../utils/functions";

const SettingsMain = () => {
  useEffect(() => {
    trackEvent(SETTINGS_PAGE);
    logEvents(SETTINGS_PAGE);
  }, []);
  return (
    <div>
      <Outlet context={{}} />
    </div>
  );
};

export default SettingsMain;
